export const buildQueryParams = (queryParams: any) => {
    const definedKeys = Object.keys(queryParams).filter((key) => {
        const value = queryParams[key];
        return value !== undefined && value !== null && !(typeof value === 'number' && isNaN(value));
    });
    if (definedKeys.length === 0) return '';
    return definedKeys.reduce(
        (str, key, i) => `${str}${key}=${queryParams[key]}${i < definedKeys.length - 1 ? '&' : ''}`,
        '?'
    );
};
